<!--系统logo-->
<template>
  <div class="sys_logo_box">
    <div class="sys_marker logo1" v-if="this.$route.path.indexOf('/yxglxt')>-1"></div>
    <div class="sys_marker logo1" v-else-if="this.$route.path.indexOf('/yxzcxt')>-1"></div>
    <div class="sys_marker logo2" v-else-if="this.$route.path.indexOf('/nzywsjgl')>-1"></div>
    <i class="njq-cangkuguanli njqIconfont" v-else style="position: relative;font-size: 32px;color: #fff" ></i>
    <span class="title">{{name}}</span>
  </div>
</template>

<script>
export default {
  name: "sys_logo",
  props: {
    name: ''
  }
}
</script>

<style lang="scss" scoped>
.sys_logo_box {
  position: absolute;
  z-index: 10;
  left: 21px;
  top: 8px;
  display: flex;
  align-items: center;
  height: 40px;
  .title {
    font-weight: bold;
    font-size: 24px;
    color: #fff;
    margin-left: 8px;
  }

  .sys_marker {
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../../../static/image_sys/sub_system/运行管理.png");
  }

  .logo1 {
    background-image: url("../../../../static/image_sys/sub_system/运行管理.png");
  }

  .logo2 {
    background-image: url("../../../../static/image_sys/sub_system/供应商管理.png");
  }

}
</style>



// WEBPACK FOOTER //
// src/studio/sub_systems/sub_system_common_components/sys_logo.vue